<template>
	<div class="flex align-items-center justify-content-center" style="min-height: 80vh;">
		<PCard class="w-full" style="max-width: 28rem;">
			<template #title>
				<div class="text-2xl font-bold text-primary">Change password</div>
			</template>
			<template #subtitle>
				<span v-if="forced">You must change your password before continuing.</span>
				<span v-else>Update your account password.</span>
			</template>
			<template #content>
				<form @submit.prevent="doChange()">
					<label class="block text-900 font-medium mb-2" for="current">Current password</label>
					<PInputText
						autocomplete="current-password"
						class="w-full mb-3"
						id="current"
						type="password"
						v-model="currentPassword"
					/>

					<label class="block text-900 font-medium mb-2" for="new">New password</label>
					<PInputText
						autocomplete="new-password"
						class="w-full mb-3"
						id="new"
						type="password"
						v-model="newPassword"
					/>

					<label class="block text-900 font-medium mb-2" for="confirm">Confirm new password</label>
					<PInputText
						autocomplete="new-password"
						class="w-full mb-3"
						id="confirm"
						type="password"
						v-model="confirmPassword"
					/>

					<PButton
						:loading="loading"
						class="p-button-raised w-full mt-2"
						label="Update password"
						type="submit"
					></PButton>
				</form>
			</template>
		</PCard>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Utils from '@/utils/Utils'
	import store from '@/store'
	import AuthManager from '@/utils/AuthManager'
	import AuthBroker from '@/brokers/AuthBroker'

	export default defineComponent({
		data() {
			return {
				loading: false,
				currentPassword: '',
				newPassword: '',
				confirmPassword: '',
			}
		},
		computed: {
			forced(): boolean {
				return store.getters.getMustChangePassword
			},
		},
		methods: {
			async doChange() {
				if (!this.currentPassword || !this.newPassword) {
					Utils.showErrorMessage('Please fill in all fields.')
					return
				}
				if (this.newPassword.length < 8) {
					Utils.showErrorMessage('New password must be at least 8 characters.')
					return
				}
				if (this.newPassword !== this.confirmPassword) {
					Utils.showErrorMessage('New password and confirmation do not match.')
					return
				}

				this.loading = true
				try {
					const res = await AuthBroker.changePassword(this.currentPassword, this.newPassword)
					if (res && res.status === 'success') {
						Utils.showSuccessMessage('Password updated successfully.')
						// Refresh /me so mustChangePassword clears, then go to dashboard.
						await AuthManager.restore()
						Utils.navigateTo('/', true)
					} else {
						Utils.showErrorMessage((res && res.message) || 'Could not update password.')
					}
				} catch (error: any) {
					const message = error?.response?.data?.message || 'Current password is incorrect.'
					Utils.showErrorMessage(message)
				} finally {
					this.loading = false
				}
			},
		},
	})
</script>
